import React, { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';
import { colors } from '~/styles';

const S = {
  TableWrapper: styled.div`
    overflow-x: auto;
    margin: 0.75rem 0;

    > table {
      width: 100%;
      border-collapse: collapse;
      font-size: 0.75rem;
      table-layout: fixed;
    }

    th,
    td {
      padding: 0.5rem 0.75rem;
      text-align: left;
      border-bottom: 1px solid ${colors.grey10};
    }

    tr:last-child td {
      border-bottom: none;
    }

    th {
      font-weight: 600;
      background: ${colors.grey5};
      border-bottom: 2px solid ${colors.grey20};
    }

    tr:hover {
      background: ${colors.grey5};
    }
  `,
};

const ALLOWED_ELEMENTS = [
  'p',
  'a',
  'h1',
  'h2',
  'h3',
  'ul',
  'ol',
  'li',
  'strong',
  'em',
  'pre',
  'code',
  'blockquote',
  'br',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
];

const COMPONENTS = {
  a: ({ children, href, ...props }) => {
    const isInternal = href?.startsWith('/');
    return (
      <a href={href} {...props} {...(!isInternal && { target: '_blank', rel: 'noopener noreferrer' })}>
        {children}
      </a>
    );
  },
  table: ({ children, ...props }) => (
    <S.TableWrapper>
      <table {...props}>{children}</table>
    </S.TableWrapper>
  ),
  th: ({ children, style, ...props }) => (
    <th style={style} {...props}>
      {children}
    </th>
  ),
  td: ({ children, style, ...props }) => (
    <td style={style} {...props}>
      {children}
    </td>
  ),
};

const REMARK_PLUGINS = [remarkGfm];

function AssistantMarkdown({ content }) {
  return (
    <ReactMarkdown
      remarkPlugins={REMARK_PLUGINS}
      allowedElements={ALLOWED_ELEMENTS}
      unwrapDisallowed
      components={COMPONENTS}>
      {content}
    </ReactMarkdown>
  );
}

export default memo(AssistantMarkdown);
